module.exports = __webpack_public_path__ + "media/images/diy/wall_wash_blue_lighting_for_prom-098b0b79e1800a2fbc24b42e39b30557.png";